// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file analytics_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ServiceProviderStatsSchema } from "./analytics_pb";
import { file_analytics } from "./analytics_pb";
import type { DriverMetric, DriverMetricJson, EngineHoursSource, EngineHoursSourceJson, JobCategory, JobCategoryJson, JobMetric, JobMetricJson, JobStatus, JobStatusJson, JobType, JobTypeJson, RouteCategory, RouteCategoryJson, RouteStatus, RouteStatusJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateFilter, DateFilterJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file analytics_service.proto.
 */
export const file_analytics_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_analytics, file_enums, file_general, file_google_protobuf_timestamp]);

/**
 * 1-3. Job time series — revenue / ordered / completed, unified behind one metric.
 * JobMetric is defined in enums.proto.
 *
 * @generated from message raccoonai.DailyValue
 */
export type DailyValue = Message<"raccoonai.DailyValue"> & {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: optional string date = 1;
   */
  date: string;

  /**
   * revenue (whole tenge) or count, per metric
   *
   * @generated from field: optional uint64 value = 2;
   */
  value: bigint;
};

/**
 * 1-3. Job time series — revenue / ordered / completed, unified behind one metric.
 * JobMetric is defined in enums.proto.
 *
 * @generated from message raccoonai.DailyValue
 */
export type DailyValueJson = {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: optional string date = 1;
   */
  date?: string;

  /**
   * revenue (whole tenge) or count, per metric
   *
   * @generated from field: optional uint64 value = 2;
   */
  value?: string;
};

/**
 * Describes the message raccoonai.DailyValue.
 * Use `create(DailyValueSchema)` to create a new message.
 */
export const DailyValueSchema: GenMessage<DailyValue, {jsonType: DailyValueJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 0);

/**
 * GetJobMetricSeries request. location_id applies only to ORDERED, driver_id only to
 * COMPLETED; both are ignored for REVENUE.
 *
 * owner_organization_id and owner_organization_ids select the organizations the series is
 * computed over; the caller must hold analytics view access on each of them (Permify decides,
 * so admins can query the orgs they administer).
 *
 * @generated from message raccoonai.JobMetricSeriesRequest
 */
export type JobMetricSeriesRequest = Message<"raccoonai.JobMetricSeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: required raccoonai.JobMetric metric = 3;
   */
  metric: JobMetric;

  /**
   * @generated from field: optional uint64 location_id = 4 [json_name = "location_id"];
   */
  locationId: bigint;

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 6 [json_name = "job_category"];
   */
  jobCategory: JobCategory;

  /**
   * @generated from field: optional uint64 service_receiver_id = 7 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 8 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * GetJobMetricSeries request. location_id applies only to ORDERED, driver_id only to
 * COMPLETED; both are ignored for REVENUE.
 *
 * owner_organization_id and owner_organization_ids select the organizations the series is
 * computed over; the caller must hold analytics view access on each of them (Permify decides,
 * so admins can query the orgs they administer).
 *
 * @generated from message raccoonai.JobMetricSeriesRequest
 */
export type JobMetricSeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: required raccoonai.JobMetric metric = 3;
   */
  metric?: JobMetricJson;

  /**
   * @generated from field: optional uint64 location_id = 4 [json_name = "location_id"];
   */
  location_id?: string;

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 6 [json_name = "job_category"];
   */
  job_category?: JobCategoryJson;

  /**
   * @generated from field: optional uint64 service_receiver_id = 7 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 8 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.JobMetricSeriesRequest.
 * Use `create(JobMetricSeriesRequestSchema)` to create a new message.
 */
export const JobMetricSeriesRequestSchema: GenMessage<JobMetricSeriesRequest, {jsonType: JobMetricSeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 1);

/**
 * @generated from message raccoonai.JobMetricSeriesResponse
 */
export type JobMetricSeriesResponse = Message<"raccoonai.JobMetricSeriesResponse"> & {
  /**
   * @generated from field: optional uint64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 2 [json_name = "per_day"];
   */
  perDay: DailyValue[];
};

/**
 * @generated from message raccoonai.JobMetricSeriesResponse
 */
export type JobMetricSeriesResponseJson = {
  /**
   * @generated from field: optional uint64 total = 1;
   */
  total?: string;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 2 [json_name = "per_day"];
   */
  per_day?: DailyValueJson[];
};

/**
 * Describes the message raccoonai.JobMetricSeriesResponse.
 * Use `create(JobMetricSeriesResponseSchema)` to create a new message.
 */
export const JobMetricSeriesResponseSchema: GenMessage<JobMetricSeriesResponse, {jsonType: JobMetricSeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 2);

/**
 * 4. drivers_summary_for_period — completed jobs per driver, keyed by geo_group,
 *    plus the driver's shift count over the period.
 *
 * @generated from message raccoonai.DriversSummaryRequest
 */
export type DriversSummaryRequest = Message<"raccoonai.DriversSummaryRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * 4. drivers_summary_for_period — completed jobs per driver, keyed by geo_group,
 *    plus the driver's shift count over the period.
 *
 * @generated from message raccoonai.DriversSummaryRequest
 */
export type DriversSummaryRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.DriversSummaryRequest.
 * Use `create(DriversSummaryRequestSchema)` to create a new message.
 */
export const DriversSummaryRequestSchema: GenMessage<DriversSummaryRequest, {jsonType: DriversSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 3);

/**
 * @generated from message raccoonai.DriverSummary
 */
export type DriverSummary = Message<"raccoonai.DriverSummary"> & {
  /**
   * @generated from field: optional uint64 driver_id = 1 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * key = pickup_location.geo_group, value = completed jobs in that group
   *
   * @generated from field: map<string, uint64> jobs_by_geo_group = 2 [json_name = "jobs_by_geo_group"];
   */
  jobsByGeoGroup: { [key: string]: bigint };

  /**
   * @generated from field: optional uint64 total_shifts = 3 [json_name = "total_shifts"];
   */
  totalShifts: bigint;
};

/**
 * @generated from message raccoonai.DriverSummary
 */
export type DriverSummaryJson = {
  /**
   * @generated from field: optional uint64 driver_id = 1 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * key = pickup_location.geo_group, value = completed jobs in that group
   *
   * @generated from field: map<string, uint64> jobs_by_geo_group = 2 [json_name = "jobs_by_geo_group"];
   */
  jobs_by_geo_group?: { [key: string]: string };

  /**
   * @generated from field: optional uint64 total_shifts = 3 [json_name = "total_shifts"];
   */
  total_shifts?: string;
};

/**
 * Describes the message raccoonai.DriverSummary.
 * Use `create(DriverSummarySchema)` to create a new message.
 */
export const DriverSummarySchema: GenMessage<DriverSummary, {jsonType: DriverSummaryJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 4);

/**
 * @generated from message raccoonai.DriversSummaryResponse
 */
export type DriversSummaryResponse = Message<"raccoonai.DriversSummaryResponse"> & {
  /**
   * @generated from field: repeated raccoonai.DriverSummary drivers = 1;
   */
  drivers: DriverSummary[];
};

/**
 * @generated from message raccoonai.DriversSummaryResponse
 */
export type DriversSummaryResponseJson = {
  /**
   * @generated from field: repeated raccoonai.DriverSummary drivers = 1;
   */
  drivers?: DriverSummaryJson[];
};

/**
 * Describes the message raccoonai.DriversSummaryResponse.
 * Use `create(DriversSummaryResponseSchema)` to create a new message.
 */
export const DriversSummaryResponseSchema: GenMessage<DriversSummaryResponse, {jsonType: DriversSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 5);

/**
 * 5. monthly_jobs_for_period -> per-job detail rows over the period.
 *
 * @generated from message raccoonai.JobDetailsRequest
 */
export type JobDetailsRequest = Message<"raccoonai.JobDetailsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * 5. monthly_jobs_for_period -> per-job detail rows over the period.
 *
 * @generated from message raccoonai.JobDetailsRequest
 */
export type JobDetailsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.JobDetailsRequest.
 * Use `create(JobDetailsRequestSchema)` to create a new message.
 */
export const JobDetailsRequestSchema: GenMessage<JobDetailsRequest, {jsonType: JobDetailsRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 6);

/**
 * @generated from message raccoonai.JobDetailRow
 */
export type JobDetailRow = Message<"raccoonai.JobDetailRow"> & {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional string truck_plate = 2 [json_name = "truck_plate"];
   */
  truckPlate: string;

  /**
   * @generated from field: optional string driver_name = 3 [json_name = "driver_name"];
   */
  driverName: string;

  /**
   * job.created_at
   *
   * @generated from field: optional google.protobuf.Timestamp ordered_at = 4 [json_name = "ordered_at"];
   */
  orderedAt?: Timestamp;

  /**
   * YYYY-MM-DD of COALESCE(fact_end_at, plan_end_at)
   *
   * @generated from field: optional string completed_on = 5 [json_name = "completed_on"];
   */
  completedOn: string;

  /**
   * @generated from field: optional string pickup_location = 6 [json_name = "pickup_location"];
   */
  pickupLocation: string;

  /**
   * service receiver org name
   *
   * @generated from field: optional string receiver = 7;
   */
  receiver: string;

  /**
   * COALESCE(NULLIF(contract.tariff,0), pickup.tariff)
   *
   * @generated from field: optional uint64 tariff = 8;
   */
  tariff: bigint;

  /**
   * contract.rent_cost
   *
   * @generated from field: optional uint64 rent = 9;
   */
  rent: bigint;

  /**
   * job.job_tariff
   *
   * @generated from field: optional uint64 total = 10;
   */
  total: bigint;

  /**
   * @generated from field: optional raccoonai.JobType type = 11;
   */
  type: JobType;

  /**
   * @generated from field: optional double netto_kg = 12 [json_name = "netto_kg"];
   */
  nettoKg: number;

  /**
   * @generated from field: optional double volume_m3 = 13 [json_name = "volume_m3"];
   */
  volumeM3: number;
};

/**
 * @generated from message raccoonai.JobDetailRow
 */
export type JobDetailRowJson = {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional string truck_plate = 2 [json_name = "truck_plate"];
   */
  truck_plate?: string;

  /**
   * @generated from field: optional string driver_name = 3 [json_name = "driver_name"];
   */
  driver_name?: string;

  /**
   * job.created_at
   *
   * @generated from field: optional google.protobuf.Timestamp ordered_at = 4 [json_name = "ordered_at"];
   */
  ordered_at?: TimestampJson;

  /**
   * YYYY-MM-DD of COALESCE(fact_end_at, plan_end_at)
   *
   * @generated from field: optional string completed_on = 5 [json_name = "completed_on"];
   */
  completed_on?: string;

  /**
   * @generated from field: optional string pickup_location = 6 [json_name = "pickup_location"];
   */
  pickup_location?: string;

  /**
   * service receiver org name
   *
   * @generated from field: optional string receiver = 7;
   */
  receiver?: string;

  /**
   * COALESCE(NULLIF(contract.tariff,0), pickup.tariff)
   *
   * @generated from field: optional uint64 tariff = 8;
   */
  tariff?: string;

  /**
   * contract.rent_cost
   *
   * @generated from field: optional uint64 rent = 9;
   */
  rent?: string;

  /**
   * job.job_tariff
   *
   * @generated from field: optional uint64 total = 10;
   */
  total?: string;

  /**
   * @generated from field: optional raccoonai.JobType type = 11;
   */
  type?: JobTypeJson;

  /**
   * @generated from field: optional double netto_kg = 12 [json_name = "netto_kg"];
   */
  netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double volume_m3 = 13 [json_name = "volume_m3"];
   */
  volume_m3?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.JobDetailRow.
 * Use `create(JobDetailRowSchema)` to create a new message.
 */
export const JobDetailRowSchema: GenMessage<JobDetailRow, {jsonType: JobDetailRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 7);

/**
 * @generated from message raccoonai.JobDetailsResponse
 */
export type JobDetailsResponse = Message<"raccoonai.JobDetailsResponse"> & {
  /**
   * @generated from field: repeated raccoonai.JobDetailRow rows = 1;
   */
  rows: JobDetailRow[];
};

/**
 * @generated from message raccoonai.JobDetailsResponse
 */
export type JobDetailsResponseJson = {
  /**
   * @generated from field: repeated raccoonai.JobDetailRow rows = 1;
   */
  rows?: JobDetailRowJson[];
};

/**
 * Describes the message raccoonai.JobDetailsResponse.
 * Use `create(JobDetailsResponseSchema)` to create a new message.
 */
export const JobDetailsResponseSchema: GenMessage<JobDetailsResponse, {jsonType: JobDetailsResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 8);

/**
 * 6. service_provider_stats — point-in-time snapshot (reuses ServiceProviderStats).
 *
 * @generated from message raccoonai.ServiceProviderStatsRequest
 */
export type ServiceProviderStatsRequest = Message<"raccoonai.ServiceProviderStatsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 2 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * 6. service_provider_stats — point-in-time snapshot (reuses ServiceProviderStats).
 *
 * @generated from message raccoonai.ServiceProviderStatsRequest
 */
export type ServiceProviderStatsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 2 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ServiceProviderStatsRequest.
 * Use `create(ServiceProviderStatsRequestSchema)` to create a new message.
 */
export const ServiceProviderStatsRequestSchema: GenMessage<ServiceProviderStatsRequest, {jsonType: ServiceProviderStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 9);

/**
 * 7. gas_levels — calibrated fuel-level series for a single truck, averaged into
 *    interval_minutes-wide buckets. Backed by the ClickHouse `calibrated_gas_level_pm`
 *    materialized view (per-minute calibrated readings from gps_raw_data).
 * Tenancy is authorized against the truck's real owning organization, resolved server-side
 * from truck_id, so a foreign truck id can never expose another tenant's telemetry.
 * owner_organization_id is carried for consistency with the other analytics requests.
 *
 * @generated from message raccoonai.GasLevelSeriesRequest
 */
export type GasLevelSeriesRequest = Message<"raccoonai.GasLevelSeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Inclusive YYYY-MM-DD range, resolved to [from 00:00:00, to 23:59:59.999999999] UTC.
   *
   * @generated from field: required raccoonai.DateFilter period = 3;
   */
  period?: DateFilter;

  /**
   * Bucket width in minutes. Defaults to 60 (hourly) when unset or 0.
   *
   * @generated from field: optional uint32 interval_minutes = 4 [json_name = "interval_minutes"];
   */
  intervalMinutes: number;
};

/**
 * 7. gas_levels — calibrated fuel-level series for a single truck, averaged into
 *    interval_minutes-wide buckets. Backed by the ClickHouse `calibrated_gas_level_pm`
 *    materialized view (per-minute calibrated readings from gps_raw_data).
 * Tenancy is authorized against the truck's real owning organization, resolved server-side
 * from truck_id, so a foreign truck id can never expose another tenant's telemetry.
 * owner_organization_id is carried for consistency with the other analytics requests.
 *
 * @generated from message raccoonai.GasLevelSeriesRequest
 */
export type GasLevelSeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Inclusive YYYY-MM-DD range, resolved to [from 00:00:00, to 23:59:59.999999999] UTC.
   *
   * @generated from field: required raccoonai.DateFilter period = 3;
   */
  period?: DateFilterJson;

  /**
   * Bucket width in minutes. Defaults to 60 (hourly) when unset or 0.
   *
   * @generated from field: optional uint32 interval_minutes = 4 [json_name = "interval_minutes"];
   */
  interval_minutes?: number;
};

/**
 * Describes the message raccoonai.GasLevelSeriesRequest.
 * Use `create(GasLevelSeriesRequestSchema)` to create a new message.
 */
export const GasLevelSeriesRequestSchema: GenMessage<GasLevelSeriesRequest, {jsonType: GasLevelSeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 10);

/**
 * @generated from message raccoonai.GasLevelPoint
 */
export type GasLevelPoint = Message<"raccoonai.GasLevelPoint"> & {
  /**
   * Start of the bucket.
   *
   * @generated from field: optional google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * Average calibrated fuel level over the bucket, in litres.
   *
   * @generated from field: optional double gas_level = 2 [json_name = "gas_level"];
   */
  gasLevel: number;
};

/**
 * @generated from message raccoonai.GasLevelPoint
 */
export type GasLevelPointJson = {
  /**
   * Start of the bucket.
   *
   * @generated from field: optional google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: TimestampJson;

  /**
   * Average calibrated fuel level over the bucket, in litres.
   *
   * @generated from field: optional double gas_level = 2 [json_name = "gas_level"];
   */
  gas_level?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.GasLevelPoint.
 * Use `create(GasLevelPointSchema)` to create a new message.
 */
export const GasLevelPointSchema: GenMessage<GasLevelPoint, {jsonType: GasLevelPointJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 11);

/**
 * @generated from message raccoonai.GasLevelSeriesResponse
 */
export type GasLevelSeriesResponse = Message<"raccoonai.GasLevelSeriesResponse"> & {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: repeated raccoonai.GasLevelPoint points = 2;
   */
  points: GasLevelPoint[];
};

/**
 * @generated from message raccoonai.GasLevelSeriesResponse
 */
export type GasLevelSeriesResponseJson = {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: repeated raccoonai.GasLevelPoint points = 2;
   */
  points?: GasLevelPointJson[];
};

/**
 * Describes the message raccoonai.GasLevelSeriesResponse.
 * Use `create(GasLevelSeriesResponseSchema)` to create a new message.
 */
export const GasLevelSeriesResponseSchema: GenMessage<GasLevelSeriesResponse, {jsonType: GasLevelSeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 12);

/**
 * @generated from message raccoonai.DriverActivitySeriesRequest
 */
export type DriverActivitySeriesRequest = Message<"raccoonai.DriverActivitySeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: required raccoonai.DriverMetric metric = 3;
   */
  metric: DriverMetric;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 5 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 6 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.DriverActivitySeriesRequest
 */
export type DriverActivitySeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: required raccoonai.DriverMetric metric = 3;
   */
  metric?: DriverMetricJson;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 5 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 6 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.DriverActivitySeriesRequest.
 * Use `create(DriverActivitySeriesRequestSchema)` to create a new message.
 */
export const DriverActivitySeriesRequestSchema: GenMessage<DriverActivitySeriesRequest, {jsonType: DriverActivitySeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 13);

/**
 * @generated from message raccoonai.DriverActivitySeriesResponse
 */
export type DriverActivitySeriesResponse = Message<"raccoonai.DriverActivitySeriesResponse"> & {
  /**
   * @generated from field: optional uint64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 2 [json_name = "per_day"];
   */
  perDay: DailyValue[];
};

/**
 * @generated from message raccoonai.DriverActivitySeriesResponse
 */
export type DriverActivitySeriesResponseJson = {
  /**
   * @generated from field: optional uint64 total = 1;
   */
  total?: string;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 2 [json_name = "per_day"];
   */
  per_day?: DailyValueJson[];
};

/**
 * Describes the message raccoonai.DriverActivitySeriesResponse.
 * Use `create(DriverActivitySeriesResponseSchema)` to create a new message.
 */
export const DriverActivitySeriesResponseSchema: GenMessage<DriverActivitySeriesResponse, {jsonType: DriverActivitySeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 14);

/**
 * @generated from message raccoonai.RouteCategorySeriesRequest
 */
export type RouteCategorySeriesRequest = Message<"raccoonai.RouteCategorySeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.RouteCategorySeriesRequest
 */
export type RouteCategorySeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.RouteCategorySeriesRequest.
 * Use `create(RouteCategorySeriesRequestSchema)` to create a new message.
 */
export const RouteCategorySeriesRequestSchema: GenMessage<RouteCategorySeriesRequest, {jsonType: RouteCategorySeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 15);

/**
 * @generated from message raccoonai.RouteCategorySeries
 */
export type RouteCategorySeries = Message<"raccoonai.RouteCategorySeries"> & {
  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 1 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;

  /**
   * @generated from field: optional uint64 total = 2;
   */
  total: bigint;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 3 [json_name = "per_day"];
   */
  perDay: DailyValue[];
};

/**
 * @generated from message raccoonai.RouteCategorySeries
 */
export type RouteCategorySeriesJson = {
  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 1 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;

  /**
   * @generated from field: optional uint64 total = 2;
   */
  total?: string;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 3 [json_name = "per_day"];
   */
  per_day?: DailyValueJson[];
};

/**
 * Describes the message raccoonai.RouteCategorySeries.
 * Use `create(RouteCategorySeriesSchema)` to create a new message.
 */
export const RouteCategorySeriesSchema: GenMessage<RouteCategorySeries, {jsonType: RouteCategorySeriesJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 16);

/**
 * @generated from message raccoonai.RouteCategorySeriesResponse
 */
export type RouteCategorySeriesResponse = Message<"raccoonai.RouteCategorySeriesResponse"> & {
  /**
   * @generated from field: repeated raccoonai.RouteCategorySeries series = 1;
   */
  series: RouteCategorySeries[];
};

/**
 * @generated from message raccoonai.RouteCategorySeriesResponse
 */
export type RouteCategorySeriesResponseJson = {
  /**
   * @generated from field: repeated raccoonai.RouteCategorySeries series = 1;
   */
  series?: RouteCategorySeriesJson[];
};

/**
 * Describes the message raccoonai.RouteCategorySeriesResponse.
 * Use `create(RouteCategorySeriesResponseSchema)` to create a new message.
 */
export const RouteCategorySeriesResponseSchema: GenMessage<RouteCategorySeriesResponse, {jsonType: RouteCategorySeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 17);

/**
 * @generated from message raccoonai.FuelConsumptionSeriesRequest
 */
export type FuelConsumptionSeriesRequest = Message<"raccoonai.FuelConsumptionSeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.FuelConsumptionSeriesRequest
 */
export type FuelConsumptionSeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.FuelConsumptionSeriesRequest.
 * Use `create(FuelConsumptionSeriesRequestSchema)` to create a new message.
 */
export const FuelConsumptionSeriesRequestSchema: GenMessage<FuelConsumptionSeriesRequest, {jsonType: FuelConsumptionSeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 18);

/**
 * @generated from message raccoonai.DailyDoubleValue
 */
export type DailyDoubleValue = Message<"raccoonai.DailyDoubleValue"> & {
  /**
   * @generated from field: optional string date = 1;
   */
  date: string;

  /**
   * @generated from field: optional double value = 2;
   */
  value: number;
};

/**
 * @generated from message raccoonai.DailyDoubleValue
 */
export type DailyDoubleValueJson = {
  /**
   * @generated from field: optional string date = 1;
   */
  date?: string;

  /**
   * @generated from field: optional double value = 2;
   */
  value?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.DailyDoubleValue.
 * Use `create(DailyDoubleValueSchema)` to create a new message.
 */
export const DailyDoubleValueSchema: GenMessage<DailyDoubleValue, {jsonType: DailyDoubleValueJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 19);

/**
 * @generated from message raccoonai.FuelConsumptionSeriesResponse
 */
export type FuelConsumptionSeriesResponse = Message<"raccoonai.FuelConsumptionSeriesResponse"> & {
  /**
   * @generated from field: optional double total_litres = 1 [json_name = "total_litres"];
   */
  totalLitres: number;

  /**
   * @generated from field: optional double avg_litres_per_100km = 2 [json_name = "avg_litres_per_100km"];
   */
  avgLitresPer100km: number;

  /**
   * @generated from field: repeated raccoonai.DailyDoubleValue per_day = 3 [json_name = "per_day"];
   */
  perDay: DailyDoubleValue[];
};

/**
 * @generated from message raccoonai.FuelConsumptionSeriesResponse
 */
export type FuelConsumptionSeriesResponseJson = {
  /**
   * @generated from field: optional double total_litres = 1 [json_name = "total_litres"];
   */
  total_litres?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double avg_litres_per_100km = 2 [json_name = "avg_litres_per_100km"];
   */
  avg_litres_per_100km?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated raccoonai.DailyDoubleValue per_day = 3 [json_name = "per_day"];
   */
  per_day?: DailyDoubleValueJson[];
};

/**
 * Describes the message raccoonai.FuelConsumptionSeriesResponse.
 * Use `create(FuelConsumptionSeriesResponseSchema)` to create a new message.
 */
export const FuelConsumptionSeriesResponseSchema: GenMessage<FuelConsumptionSeriesResponse, {jsonType: FuelConsumptionSeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 20);

/**
 * @generated from message raccoonai.EngineHoursSeriesRequest
 */
export type EngineHoursSeriesRequest = Message<"raccoonai.EngineHoursSeriesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.EngineHoursSeriesRequest
 */
export type EngineHoursSeriesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.EngineHoursSeriesRequest.
 * Use `create(EngineHoursSeriesRequestSchema)` to create a new message.
 */
export const EngineHoursSeriesRequestSchema: GenMessage<EngineHoursSeriesRequest, {jsonType: EngineHoursSeriesRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 21);

/**
 * @generated from message raccoonai.EngineHoursSeriesResponse
 */
export type EngineHoursSeriesResponse = Message<"raccoonai.EngineHoursSeriesResponse"> & {
  /**
   * @generated from field: optional uint64 total_seconds = 1 [json_name = "total_seconds"];
   */
  totalSeconds: bigint;

  /**
   * @generated from field: optional uint64 avg_seconds_per_shift = 2 [json_name = "avg_seconds_per_shift"];
   */
  avgSecondsPerShift: bigint;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 3 [json_name = "per_day"];
   */
  perDay: DailyValue[];
};

/**
 * @generated from message raccoonai.EngineHoursSeriesResponse
 */
export type EngineHoursSeriesResponseJson = {
  /**
   * @generated from field: optional uint64 total_seconds = 1 [json_name = "total_seconds"];
   */
  total_seconds?: string;

  /**
   * @generated from field: optional uint64 avg_seconds_per_shift = 2 [json_name = "avg_seconds_per_shift"];
   */
  avg_seconds_per_shift?: string;

  /**
   * @generated from field: repeated raccoonai.DailyValue per_day = 3 [json_name = "per_day"];
   */
  per_day?: DailyValueJson[];
};

/**
 * Describes the message raccoonai.EngineHoursSeriesResponse.
 * Use `create(EngineHoursSeriesResponseSchema)` to create a new message.
 */
export const EngineHoursSeriesResponseSchema: GenMessage<EngineHoursSeriesResponse, {jsonType: EngineHoursSeriesResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 22);

/**
 * @generated from message raccoonai.TruckWorkSummaryRequest
 */
export type TruckWorkSummaryRequest = Message<"raccoonai.TruckWorkSummaryRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.TruckWorkSummaryRequest
 */
export type TruckWorkSummaryRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 4 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.TruckWorkSummaryRequest.
 * Use `create(TruckWorkSummaryRequestSchema)` to create a new message.
 */
export const TruckWorkSummaryRequestSchema: GenMessage<TruckWorkSummaryRequest, {jsonType: TruckWorkSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 23);

/**
 * @generated from message raccoonai.TruckWorkRow
 */
export type TruckWorkRow = Message<"raccoonai.TruckWorkRow"> & {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional string plate_number = 2 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * @generated from field: optional uint64 shifts = 3;
   */
  shifts: bigint;

  /**
   * @generated from field: optional uint64 routes_completed = 4 [json_name = "routes_completed"];
   */
  routesCompleted: bigint;

  /**
   * @generated from field: optional uint64 jobs_completed = 5 [json_name = "jobs_completed"];
   */
  jobsCompleted: bigint;

  /**
   * @generated from field: optional double netto_kg = 6 [json_name = "netto_kg"];
   */
  nettoKg: number;

  /**
   * @generated from field: optional double mileage_km = 7 [json_name = "mileage_km"];
   */
  mileageKm: number;

  /**
   * @generated from field: optional uint64 engine_seconds = 8 [json_name = "engine_seconds"];
   */
  engineSeconds: bigint;

  /**
   * @generated from field: optional double fuel_litres = 9 [json_name = "fuel_litres"];
   */
  fuelLitres: number;
};

/**
 * @generated from message raccoonai.TruckWorkRow
 */
export type TruckWorkRowJson = {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional string plate_number = 2 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * @generated from field: optional uint64 shifts = 3;
   */
  shifts?: string;

  /**
   * @generated from field: optional uint64 routes_completed = 4 [json_name = "routes_completed"];
   */
  routes_completed?: string;

  /**
   * @generated from field: optional uint64 jobs_completed = 5 [json_name = "jobs_completed"];
   */
  jobs_completed?: string;

  /**
   * @generated from field: optional double netto_kg = 6 [json_name = "netto_kg"];
   */
  netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double mileage_km = 7 [json_name = "mileage_km"];
   */
  mileage_km?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 engine_seconds = 8 [json_name = "engine_seconds"];
   */
  engine_seconds?: string;

  /**
   * @generated from field: optional double fuel_litres = 9 [json_name = "fuel_litres"];
   */
  fuel_litres?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.TruckWorkRow.
 * Use `create(TruckWorkRowSchema)` to create a new message.
 */
export const TruckWorkRowSchema: GenMessage<TruckWorkRow, {jsonType: TruckWorkRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 24);

/**
 * @generated from message raccoonai.TruckWorkSummaryResponse
 */
export type TruckWorkSummaryResponse = Message<"raccoonai.TruckWorkSummaryResponse"> & {
  /**
   * @generated from field: repeated raccoonai.TruckWorkRow rows = 1;
   */
  rows: TruckWorkRow[];
};

/**
 * @generated from message raccoonai.TruckWorkSummaryResponse
 */
export type TruckWorkSummaryResponseJson = {
  /**
   * @generated from field: repeated raccoonai.TruckWorkRow rows = 1;
   */
  rows?: TruckWorkRowJson[];
};

/**
 * Describes the message raccoonai.TruckWorkSummaryResponse.
 * Use `create(TruckWorkSummaryResponseSchema)` to create a new message.
 */
export const TruckWorkSummaryResponseSchema: GenMessage<TruckWorkSummaryResponse, {jsonType: TruckWorkSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 25);

/**
 * Моточасы per driver shift, for the admin ТТН (waybill) page. One row per shift, over the
 * same shift work window the engine-hours series uses, so both screens agree.
 *
 * @generated from message raccoonai.ShiftEngineHoursRequest
 */
export type ShiftEngineHoursRequest = Message<"raccoonai.ShiftEngineHoursRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * Моточасы per driver shift, for the admin ТТН (waybill) page. One row per shift, over the
 * same shift work window the engine-hours series uses, so both screens agree.
 *
 * @generated from message raccoonai.ShiftEngineHoursRequest
 */
export type ShiftEngineHoursRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ShiftEngineHoursRequest.
 * Use `create(ShiftEngineHoursRequestSchema)` to create a new message.
 */
export const ShiftEngineHoursRequestSchema: GenMessage<ShiftEngineHoursRequest, {jsonType: ShiftEngineHoursRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 26);

/**
 * window_start_at / window_end_at bound the span the figure was computed over, which is the
 * shift's work window, not necessarily its full created-to-completed life.
 *
 * @generated from message raccoonai.ShiftEngineHoursRow
 */
export type ShiftEngineHoursRow = Message<"raccoonai.ShiftEngineHoursRow"> & {
  /**
   * @generated from field: optional uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_start_at = 4 [json_name = "window_start_at"];
   */
  windowStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_end_at = 5 [json_name = "window_end_at"];
   */
  windowEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 window_seconds = 6 [json_name = "window_seconds"];
   */
  windowSeconds: bigint;

  /**
   * Unset when source is NONE -- absent telemetry is not zero engine time.
   *
   * @generated from field: optional uint64 engine_seconds = 7 [json_name = "engine_seconds"];
   */
  engineSeconds: bigint;

  /**
   * @generated from field: optional raccoonai.EngineHoursSource source = 8;
   */
  source: EngineHoursSource;
};

/**
 * window_start_at / window_end_at bound the span the figure was computed over, which is the
 * shift's work window, not necessarily its full created-to-completed life.
 *
 * @generated from message raccoonai.ShiftEngineHoursRow
 */
export type ShiftEngineHoursRowJson = {
  /**
   * @generated from field: optional uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_start_at = 4 [json_name = "window_start_at"];
   */
  window_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_end_at = 5 [json_name = "window_end_at"];
   */
  window_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 window_seconds = 6 [json_name = "window_seconds"];
   */
  window_seconds?: string;

  /**
   * Unset when source is NONE -- absent telemetry is not zero engine time.
   *
   * @generated from field: optional uint64 engine_seconds = 7 [json_name = "engine_seconds"];
   */
  engine_seconds?: string;

  /**
   * @generated from field: optional raccoonai.EngineHoursSource source = 8;
   */
  source?: EngineHoursSourceJson;
};

/**
 * Describes the message raccoonai.ShiftEngineHoursRow.
 * Use `create(ShiftEngineHoursRowSchema)` to create a new message.
 */
export const ShiftEngineHoursRowSchema: GenMessage<ShiftEngineHoursRow, {jsonType: ShiftEngineHoursRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 27);

/**
 * @generated from message raccoonai.ShiftEngineHoursResponse
 */
export type ShiftEngineHoursResponse = Message<"raccoonai.ShiftEngineHoursResponse"> & {
  /**
   * @generated from field: repeated raccoonai.ShiftEngineHoursRow rows = 1;
   */
  rows: ShiftEngineHoursRow[];
};

/**
 * @generated from message raccoonai.ShiftEngineHoursResponse
 */
export type ShiftEngineHoursResponseJson = {
  /**
   * @generated from field: repeated raccoonai.ShiftEngineHoursRow rows = 1;
   */
  rows?: ShiftEngineHoursRowJson[];
};

/**
 * Describes the message raccoonai.ShiftEngineHoursResponse.
 * Use `create(ShiftEngineHoursResponseSchema)` to create a new message.
 */
export const ShiftEngineHoursResponseSchema: GenMessage<ShiftEngineHoursResponse, {jsonType: ShiftEngineHoursResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 28);

/**
 * @generated from message raccoonai.ShiftUsageRequest
 */
export type ShiftUsageRequest = Message<"raccoonai.ShiftUsageRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.ShiftUsageRequest
 */
export type ShiftUsageRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ShiftUsageRequest.
 * Use `create(ShiftUsageRequestSchema)` to create a new message.
 */
export const ShiftUsageRequestSchema: GenMessage<ShiftUsageRequest, {jsonType: ShiftUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 29);

/**
 * @generated from message raccoonai.ShiftUsageRow
 */
export type ShiftUsageRow = Message<"raccoonai.ShiftUsageRow"> & {
  /**
   * @generated from field: optional uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_start_at = 4 [json_name = "window_start_at"];
   */
  windowStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_end_at = 5 [json_name = "window_end_at"];
   */
  windowEndAt?: Timestamp;

  /**
   * @generated from field: optional double mileage_km = 6 [json_name = "mileage_km"];
   */
  mileageKm: number;

  /**
   * @generated from field: optional double fuel_consumed_litres = 7 [json_name = "fuel_consumed_litres"];
   */
  fuelConsumedLitres: number;

  /**
   * @generated from field: optional double fuel_refueled_litres = 8 [json_name = "fuel_refueled_litres"];
   */
  fuelRefueledLitres: number;

  /**
   * @generated from field: optional uint64 engine_seconds = 9 [json_name = "engine_seconds"];
   */
  engineSeconds: bigint;

  /**
   * @generated from field: optional raccoonai.EngineHoursSource engine_seconds_source = 10 [json_name = "engine_seconds_source"];
   */
  engineSecondsSource: EngineHoursSource;
};

/**
 * @generated from message raccoonai.ShiftUsageRow
 */
export type ShiftUsageRowJson = {
  /**
   * @generated from field: optional uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_start_at = 4 [json_name = "window_start_at"];
   */
  window_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp window_end_at = 5 [json_name = "window_end_at"];
   */
  window_end_at?: TimestampJson;

  /**
   * @generated from field: optional double mileage_km = 6 [json_name = "mileage_km"];
   */
  mileage_km?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double fuel_consumed_litres = 7 [json_name = "fuel_consumed_litres"];
   */
  fuel_consumed_litres?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double fuel_refueled_litres = 8 [json_name = "fuel_refueled_litres"];
   */
  fuel_refueled_litres?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 engine_seconds = 9 [json_name = "engine_seconds"];
   */
  engine_seconds?: string;

  /**
   * @generated from field: optional raccoonai.EngineHoursSource engine_seconds_source = 10 [json_name = "engine_seconds_source"];
   */
  engine_seconds_source?: EngineHoursSourceJson;
};

/**
 * Describes the message raccoonai.ShiftUsageRow.
 * Use `create(ShiftUsageRowSchema)` to create a new message.
 */
export const ShiftUsageRowSchema: GenMessage<ShiftUsageRow, {jsonType: ShiftUsageRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 30);

/**
 * @generated from message raccoonai.ShiftUsageResponse
 */
export type ShiftUsageResponse = Message<"raccoonai.ShiftUsageResponse"> & {
  /**
   * @generated from field: repeated raccoonai.ShiftUsageRow rows = 1;
   */
  rows: ShiftUsageRow[];
};

/**
 * @generated from message raccoonai.ShiftUsageResponse
 */
export type ShiftUsageResponseJson = {
  /**
   * @generated from field: repeated raccoonai.ShiftUsageRow rows = 1;
   */
  rows?: ShiftUsageRowJson[];
};

/**
 * Describes the message raccoonai.ShiftUsageResponse.
 * Use `create(ShiftUsageResponseSchema)` to create a new message.
 */
export const ShiftUsageResponseSchema: GenMessage<ShiftUsageResponse, {jsonType: ShiftUsageResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 31);

/**
 * @generated from message raccoonai.TruckLatestReadingsRequest
 */
export type TruckLatestReadingsRequest = Message<"raccoonai.TruckLatestReadingsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * Empty means every truck of the organization.
   *
   * @generated from field: repeated uint64 truck_ids = 2 [json_name = "truck_ids"];
   */
  truckIds: bigint[];

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.TruckLatestReadingsRequest
 */
export type TruckLatestReadingsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * Empty means every truck of the organization.
   *
   * @generated from field: repeated uint64 truck_ids = 2 [json_name = "truck_ids"];
   */
  truck_ids?: string[];

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.TruckLatestReadingsRequest.
 * Use `create(TruckLatestReadingsRequestSchema)` to create a new message.
 */
export const TruckLatestReadingsRequestSchema: GenMessage<TruckLatestReadingsRequest, {jsonType: TruckLatestReadingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 32);

/**
 * @generated from message raccoonai.TruckLatestReadingsRow
 */
export type TruckLatestReadingsRow = Message<"raccoonai.TruckLatestReadingsRow"> & {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional double mileage_km = 2 [json_name = "mileage_km"];
   */
  mileageKm: number;

  /**
   * @generated from field: optional double mileage_today_km = 3 [json_name = "mileage_today_km"];
   */
  mileageTodayKm: number;

  /**
   * @generated from field: optional double fuel_litres = 4 [json_name = "fuel_litres"];
   */
  fuelLitres: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp read_at = 5 [json_name = "read_at"];
   */
  readAt?: Timestamp;
};

/**
 * @generated from message raccoonai.TruckLatestReadingsRow
 */
export type TruckLatestReadingsRowJson = {
  /**
   * @generated from field: optional uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional double mileage_km = 2 [json_name = "mileage_km"];
   */
  mileage_km?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double mileage_today_km = 3 [json_name = "mileage_today_km"];
   */
  mileage_today_km?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double fuel_litres = 4 [json_name = "fuel_litres"];
   */
  fuel_litres?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp read_at = 5 [json_name = "read_at"];
   */
  read_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.TruckLatestReadingsRow.
 * Use `create(TruckLatestReadingsRowSchema)` to create a new message.
 */
export const TruckLatestReadingsRowSchema: GenMessage<TruckLatestReadingsRow, {jsonType: TruckLatestReadingsRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 33);

/**
 * @generated from message raccoonai.TruckLatestReadingsResponse
 */
export type TruckLatestReadingsResponse = Message<"raccoonai.TruckLatestReadingsResponse"> & {
  /**
   * @generated from field: repeated raccoonai.TruckLatestReadingsRow rows = 1;
   */
  rows: TruckLatestReadingsRow[];
};

/**
 * @generated from message raccoonai.TruckLatestReadingsResponse
 */
export type TruckLatestReadingsResponseJson = {
  /**
   * @generated from field: repeated raccoonai.TruckLatestReadingsRow rows = 1;
   */
  rows?: TruckLatestReadingsRowJson[];
};

/**
 * Describes the message raccoonai.TruckLatestReadingsResponse.
 * Use `create(TruckLatestReadingsResponseSchema)` to create a new message.
 */
export const TruckLatestReadingsResponseSchema: GenMessage<TruckLatestReadingsResponse, {jsonType: TruckLatestReadingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 34);

/**
 * @generated from message raccoonai.RouteDetailsRequest
 */
export type RouteDetailsRequest = Message<"raccoonai.RouteDetailsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 5 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 6 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.RouteDetailsRequest
 */
export type RouteDetailsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 5 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 6 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.RouteDetailsRequest.
 * Use `create(RouteDetailsRequestSchema)` to create a new message.
 */
export const RouteDetailsRequestSchema: GenMessage<RouteDetailsRequest, {jsonType: RouteDetailsRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 35);

/**
 * @generated from message raccoonai.RouteDetailRow
 */
export type RouteDetailRow = Message<"raccoonai.RouteDetailRow"> & {
  /**
   * @generated from field: optional uint64 route_id = 1 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional string completed_on = 2 [json_name = "completed_on"];
   */
  completedOn: string;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 3 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;

  /**
   * @generated from field: optional string driver_name = 4 [json_name = "driver_name"];
   */
  driverName: string;

  /**
   * @generated from field: optional string truck_plate = 5 [json_name = "truck_plate"];
   */
  truckPlate: string;

  /**
   * @generated from field: optional uint64 jobs_total = 6 [json_name = "jobs_total"];
   */
  jobsTotal: bigint;

  /**
   * @generated from field: optional uint64 jobs_completed = 7 [json_name = "jobs_completed"];
   */
  jobsCompleted: bigint;

  /**
   * @generated from field: optional double netto_kg = 8 [json_name = "netto_kg"];
   */
  nettoKg: number;

  /**
   * @generated from field: optional uint64 reward = 9;
   */
  reward: bigint;

  /**
   * @generated from field: optional uint64 duration_seconds = 10 [json_name = "duration_seconds"];
   */
  durationSeconds: bigint;

  /**
   * @generated from field: optional raccoonai.RouteStatus status = 11;
   */
  status: RouteStatus;
};

/**
 * @generated from message raccoonai.RouteDetailRow
 */
export type RouteDetailRowJson = {
  /**
   * @generated from field: optional uint64 route_id = 1 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional string completed_on = 2 [json_name = "completed_on"];
   */
  completed_on?: string;

  /**
   * @generated from field: optional raccoonai.RouteCategory route_category = 3 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;

  /**
   * @generated from field: optional string driver_name = 4 [json_name = "driver_name"];
   */
  driver_name?: string;

  /**
   * @generated from field: optional string truck_plate = 5 [json_name = "truck_plate"];
   */
  truck_plate?: string;

  /**
   * @generated from field: optional uint64 jobs_total = 6 [json_name = "jobs_total"];
   */
  jobs_total?: string;

  /**
   * @generated from field: optional uint64 jobs_completed = 7 [json_name = "jobs_completed"];
   */
  jobs_completed?: string;

  /**
   * @generated from field: optional double netto_kg = 8 [json_name = "netto_kg"];
   */
  netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 reward = 9;
   */
  reward?: string;

  /**
   * @generated from field: optional uint64 duration_seconds = 10 [json_name = "duration_seconds"];
   */
  duration_seconds?: string;

  /**
   * @generated from field: optional raccoonai.RouteStatus status = 11;
   */
  status?: RouteStatusJson;
};

/**
 * Describes the message raccoonai.RouteDetailRow.
 * Use `create(RouteDetailRowSchema)` to create a new message.
 */
export const RouteDetailRowSchema: GenMessage<RouteDetailRow, {jsonType: RouteDetailRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 36);

/**
 * @generated from message raccoonai.RouteDetailsResponse
 */
export type RouteDetailsResponse = Message<"raccoonai.RouteDetailsResponse"> & {
  /**
   * @generated from field: repeated raccoonai.RouteDetailRow rows = 1;
   */
  rows: RouteDetailRow[];
};

/**
 * @generated from message raccoonai.RouteDetailsResponse
 */
export type RouteDetailsResponseJson = {
  /**
   * @generated from field: repeated raccoonai.RouteDetailRow rows = 1;
   */
  rows?: RouteDetailRowJson[];
};

/**
 * Describes the message raccoonai.RouteDetailsResponse.
 * Use `create(RouteDetailsResponseSchema)` to create a new message.
 */
export const RouteDetailsResponseSchema: GenMessage<RouteDetailsResponse, {jsonType: RouteDetailsResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 37);

/**
 * @generated from message raccoonai.UnfulfilledJobsRequest
 */
export type UnfulfilledJobsRequest = Message<"raccoonai.UnfulfilledJobsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilter;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 4 [json_name = "job_category"];
   */
  jobCategory: JobCategory;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.UnfulfilledJobsRequest
 */
export type UnfulfilledJobsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateFilter period = 2;
   */
  period?: DateFilterJson;

  /**
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 4 [json_name = "job_category"];
   */
  job_category?: JobCategoryJson;

  /**
   * Organizations to aggregate over, with their descendants. owner_organization_id is added and
   * duplicates dropped; one organization the caller can't view rejects the whole request.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 5 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.UnfulfilledJobsRequest.
 * Use `create(UnfulfilledJobsRequestSchema)` to create a new message.
 */
export const UnfulfilledJobsRequestSchema: GenMessage<UnfulfilledJobsRequest, {jsonType: UnfulfilledJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 38);

/**
 * @generated from message raccoonai.UnfulfilledJobRow
 */
export type UnfulfilledJobRow = Message<"raccoonai.UnfulfilledJobRow"> & {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional string date = 2;
   */
  date: string;

  /**
   * @generated from field: optional raccoonai.JobStatus status = 3;
   */
  status: JobStatus;

  /**
   * @generated from field: optional raccoonai.JobType type = 4;
   */
  type: JobType;

  /**
   * @generated from field: optional string pickup_location = 5 [json_name = "pickup_location"];
   */
  pickupLocation: string;

  /**
   * @generated from field: optional string receiver = 6;
   */
  receiver: string;

  /**
   * @generated from field: optional string driver_name = 7 [json_name = "driver_name"];
   */
  driverName: string;

  /**
   * @generated from field: optional string reason = 8;
   */
  reason: string;
};

/**
 * @generated from message raccoonai.UnfulfilledJobRow
 */
export type UnfulfilledJobRowJson = {
  /**
   * @generated from field: optional uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional string date = 2;
   */
  date?: string;

  /**
   * @generated from field: optional raccoonai.JobStatus status = 3;
   */
  status?: JobStatusJson;

  /**
   * @generated from field: optional raccoonai.JobType type = 4;
   */
  type?: JobTypeJson;

  /**
   * @generated from field: optional string pickup_location = 5 [json_name = "pickup_location"];
   */
  pickup_location?: string;

  /**
   * @generated from field: optional string receiver = 6;
   */
  receiver?: string;

  /**
   * @generated from field: optional string driver_name = 7 [json_name = "driver_name"];
   */
  driver_name?: string;

  /**
   * @generated from field: optional string reason = 8;
   */
  reason?: string;
};

/**
 * Describes the message raccoonai.UnfulfilledJobRow.
 * Use `create(UnfulfilledJobRowSchema)` to create a new message.
 */
export const UnfulfilledJobRowSchema: GenMessage<UnfulfilledJobRow, {jsonType: UnfulfilledJobRowJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 39);

/**
 * @generated from message raccoonai.UnfulfilledJobsResponse
 */
export type UnfulfilledJobsResponse = Message<"raccoonai.UnfulfilledJobsResponse"> & {
  /**
   * @generated from field: repeated raccoonai.UnfulfilledJobRow rows = 1;
   */
  rows: UnfulfilledJobRow[];
};

/**
 * @generated from message raccoonai.UnfulfilledJobsResponse
 */
export type UnfulfilledJobsResponseJson = {
  /**
   * @generated from field: repeated raccoonai.UnfulfilledJobRow rows = 1;
   */
  rows?: UnfulfilledJobRowJson[];
};

/**
 * Describes the message raccoonai.UnfulfilledJobsResponse.
 * Use `create(UnfulfilledJobsResponseSchema)` to create a new message.
 */
export const UnfulfilledJobsResponseSchema: GenMessage<UnfulfilledJobsResponse, {jsonType: UnfulfilledJobsResponseJson}> = /*@__PURE__*/
  messageDesc(file_analytics_service, 40);

/**
 * @generated from service raccoonai.AnalyticsService
 */
export const AnalyticsService: GenService<{
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetJobMetricSeries
   */
  getJobMetricSeries: {
    methodKind: "unary";
    input: typeof JobMetricSeriesRequestSchema;
    output: typeof JobMetricSeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetDriversSummary
   */
  getDriversSummary: {
    methodKind: "unary";
    input: typeof DriversSummaryRequestSchema;
    output: typeof DriversSummaryResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetJobDetails
   */
  getJobDetails: {
    methodKind: "unary";
    input: typeof JobDetailsRequestSchema;
    output: typeof JobDetailsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetServiceProviderStats
   */
  getServiceProviderStats: {
    methodKind: "unary";
    input: typeof ServiceProviderStatsRequestSchema;
    output: typeof ServiceProviderStatsSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetGasLevelSeries
   */
  getGasLevelSeries: {
    methodKind: "unary";
    input: typeof GasLevelSeriesRequestSchema;
    output: typeof GasLevelSeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetDriverActivitySeries
   */
  getDriverActivitySeries: {
    methodKind: "unary";
    input: typeof DriverActivitySeriesRequestSchema;
    output: typeof DriverActivitySeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetRouteCategorySeries
   */
  getRouteCategorySeries: {
    methodKind: "unary";
    input: typeof RouteCategorySeriesRequestSchema;
    output: typeof RouteCategorySeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetFuelConsumptionSeries
   */
  getFuelConsumptionSeries: {
    methodKind: "unary";
    input: typeof FuelConsumptionSeriesRequestSchema;
    output: typeof FuelConsumptionSeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetEngineHoursSeries
   */
  getEngineHoursSeries: {
    methodKind: "unary";
    input: typeof EngineHoursSeriesRequestSchema;
    output: typeof EngineHoursSeriesResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetTruckWorkSummary
   */
  getTruckWorkSummary: {
    methodKind: "unary";
    input: typeof TruckWorkSummaryRequestSchema;
    output: typeof TruckWorkSummaryResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetShiftEngineHours
   */
  getShiftEngineHours: {
    methodKind: "unary";
    input: typeof ShiftEngineHoursRequestSchema;
    output: typeof ShiftEngineHoursResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetShiftUsage
   */
  getShiftUsage: {
    methodKind: "unary";
    input: typeof ShiftUsageRequestSchema;
    output: typeof ShiftUsageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetTruckLatestReadings
   */
  getTruckLatestReadings: {
    methodKind: "unary";
    input: typeof TruckLatestReadingsRequestSchema;
    output: typeof TruckLatestReadingsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetRouteDetails
   */
  getRouteDetails: {
    methodKind: "unary";
    input: typeof RouteDetailsRequestSchema;
    output: typeof RouteDetailsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AnalyticsService.GetUnfulfilledJobs
   */
  getUnfulfilledJobs: {
    methodKind: "unary";
    input: typeof UnfulfilledJobsRequestSchema;
    output: typeof UnfulfilledJobsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_analytics_service, 0);

